import Vue from "vue";

/**
 * Ref: Modified and adapted from 
 * https://github.com/vuelidate/vuelidate/issues/268#issuecomment-419007072
 * 
 * Scroll to the error when validation fails
 * 
 * @param  string  The type of element the error is displayed in: alert or form group
 * @return void
 */
export function scrollToError(elementType){
    Vue.nextTick(() => {  
        let domRectElement = '';
        
        if(elementType == 'alert'){
            domRectElement = document.querySelector('.alert.error')
        }
        
        if(elementType == 'form-group'){
            domRectElement = document.querySelector('.form-group.error')
        }
        
        if(!domRectElement){
            return;
        }

        if(isElementInViewport(domRectElement)){
            return;
        }

        //We check if the element with the error is in the viewport
        let domRect = domRectElement.getBoundingClientRect();
        
        //We subtract 30 just so there is spacing on top of the error element. Feel free to add more.
        window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 30,
            behavior: 'smooth' 
        });
    
    });
}

/**
 * Ref: https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 *
 * We check if the passed element is visible in the DOM
 * @param  DOM element
 * @return boolean
 */
function isElementInViewport(element) {

    var rect = element.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && 
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function scrollTop()
{
    if ( window.scrollY != 0 ) {
         window.scrollTo(0,0);
    }
}